enum DETAIL_INFO {
  CORREO = 'Correo',
  LINKEDIN = 'LinkedIn',
  TEST_KANDIO = 'Test Kandio',
  CV = 'CV',
}

export default DETAIL_INFO;
